'use client'

import { createContext, type ReactNode, useContext } from 'react'
import type { CookieListResponse } from '@/blocks/CookieListBlock/CookieListBlock.types'

const CookieListContext = createContext<CookieListResponse | null>(null)

type Props = {
  cookieList: CookieListResponse | null
  children: ReactNode
}

export function CookieListProvider({ cookieList, children }: Props) {
  return <CookieListContext.Provider value={cookieList}>{children}</CookieListContext.Provider>
}

/**
 * Returns the server-fetched cookie list, or `null` if the upstream fetch failed
 * or no `CookieListProvider` wraps the tree. Consumers should treat both cases as
 * "render nothing".
 */
export function useCookieList(): CookieListResponse | null {
  return useContext(CookieListContext)
}
